import React from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useMutation } from '@tanstack/react-query';
import { enableUser } from '../../../services/admin/UsersService';
import { AxiosError } from 'axios';
import { showToast } from '../../../components/messages/ErrorAlert';
import firebaseErrorMessages from '../../../components/errorMessages/firebase';
import { Toast } from 'primereact/toast';

type EnableUserButtonProps = {
  userID: string;
  toastRef: React.RefObject<Toast>;
  afterEnabling?: () => void;
};

const EnableUserButton = ({
  userID,
  toastRef,
  afterEnabling,
}: EnableUserButtonProps) => {
  const enableUserResult = useMutation({
    mutationFn: () => {
      return enableUser(userID ?? '');
    },
    onSuccess: () => {
      if (afterEnabling) {
        afterEnabling();
      }
      showToast(
        'success',
        toastRef,
        'Enable User',
        'User has been enabled successfully',
        3000
      );
    },

    onError: (error: AxiosError) => {
      const errorData = error.response?.data as { code: string };
      showToast(
        'error',
        toastRef,
        'Enable User Error',
        firebaseErrorMessages[errorData?.code] ||
          'An error occurred! please try again later',
        3000
      );
    },
  });

  const onClickRemove = () => {
    confirmDialog({
      message: 'Do you want to enable this user?',
      header: 'Enable Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: enableUserResult.mutate,
    });
  };

  return (
    <div>
      <Button
        onClick={onClickRemove}
        className="w-15rem bg-green-500 border-0 flex py-3"
      >
        {enableUserResult.isLoading && (
          <ProgressSpinner className="w-3rem h-3rem" />
        )}
        {!enableUserResult.isLoading && (
          <span className="mx-auto text-22px text-white">Enable</span>
        )}
      </Button>
      <ConfirmDialog />
    </div>
  );
};

export default EnableUserButton;
